import {FormItemProps, Space} from "antd"
import MagicButton from "../../components/negotiationForm/sidebars/AIAssistant/utils/MagicButton"
import {useGetAIThoughts} from "../../components/negotiationForm/utils/useGetAIThoughts"
import {useAIFunctionality} from "../useAIFunctionality";

export const FormItemLabelWithAISuggestion = (
    {
        label,
        name,
        ...props
    }: FormItemProps
) => {

    const canShowAIFeature = useAIFunctionality();
    const checkThoughtAvailable = useGetAIThoughts()

    return <>
        {
            (canShowAIFeature && checkThoughtAvailable(name))
                ? <Space style={{width: "100%"}}>
                    {label}
                    <MagicButton
                        fieldValue={name}
                        fieldLabel={label}
                        size={"small"}
                    />
                </Space>
                : label
        }
    </>
}
